<template lang="html">
  <div>
    <template>
      <div>
        <div class="vx-card nexteventheader_div">
          <div class="vx-card__header">
            <div class="vx-card__title">
              <h4>Create Administrator</h4>
            </div>
          </div>
        </div>
      </div>
      <vx-card>
        <div>
            <form @submit.prevent="handleSubmit">
                <div class="vx-row">
                    <div class="vx-col mt-5" style="width: 60%;">
                        <label>
                            {{$t('UserRole')}}: 
                        </label>
                        <vs-select v-model="user_role" class="w-full" v-validate="'required'">
                            <vs-select-item
                                :key="index"
                                :value="item"
                                :text="item"
                                v-for="(item,index) in ['admin','admin_observer']"
                            />
                        </vs-select>
                        <span class="text-danger">{{ errors.first('user_role') }}</span>
                    </div>
                </div>
                <div class="vx-row">
                    <div class="vx-col mt-5" style="width: 60%;">
                        <label>
                            {{$t('FirstName')}}: 
                        </label>
                        <vs-input
                            v-model="firstname"
                            type="text"
                            class="w-full"
                            name="firstname"
                            v-validate="'required|alpha_spaces'"
                        />
                        <span class="text-danger">{{ errors.first('firstname') }}</span>
                    </div>
                </div>
                <div class="vx-row">
                    <div class="vx-col mt-5" style="width: 60%;">
                        <label>
                            {{$t('LastName')}}: 
                        </label>
                        <vs-input
                            v-model="lastname"
                            type="text"
                            class="w-full"
                            name="lastname"
                            v-validate="'required|alpha_spaces'"
                        />
                        <span class="text-danger">{{ errors.first('lastname') }}</span>
                    </div>
                </div>
                <div class="vx-row">
                    <div class="vx-col mt-5" style="width: 60%;">
                        <label>
                            Email: 
                        </label>
                        <vs-input
                            v-model="email"
                            type="email"
                            class="w-full"
                            name="email"
                            v-validate="'required|email'"
                        />
                        <span class="text-danger">{{ errors.first('email') }}</span>
                    </div>
                </div>
                <div class="vx-row">
                    <div class="vx-col mt-5" style="width: 60%;">
                        <label>
                            {{$t('Contact')}}: 
                        </label>
                        <vs-input
                            v-model="contact"
                            type="text"
                            class="w-full"
                            name="contact"
                            v-validate="'required|numeric'"
                        />
                        <span class="text-danger">{{ errors.first('contact') }}</span>
                    </div>
                </div>
                <div class="vx-row">
                    <div class="vx-col mt-5" style="width: 60%;">
                        <label>New Password:</label>
                        <vs-input
                            type="password"
                            v-model="newpassword"
                            class="w-full"
                            name="newpassword"
                            v-validate="'required'"
                        />
                        <span class="text-danger">{{ errors.first('newpassword') }}</span>
                    </div>
                </div>
                <div class="vx-row">
                    <div class="vx-col mt-5" style="width: 60%;">
                        <label>Confirm New Password:</label>
                        <vs-input
                            type="password"
                            v-model="confirmpassword"
                            class="w-full"
                            name="confirmpassword"
                            v-validate="'required'"
                        />
                        <span class="text-danger">{{ errors.first('confirmpassword') }}</span>
                    </div>
                </div>
                <vs-button style="margin-top: 30px;" @click="handleSubmit($event)">Update</vs-button>
            </form>
        </div>
      </vx-card>
    </template>
  </div>
</template>

<script>
import "vue-form-wizard/dist/vue-form-wizard.min.css";

export default {
  data: () => ({
    user_role: 'admin', 
    firstname: '',
    lastname: '',
    email: '',
    contact: '',
    newpassword: '',
    confirmpassword: '',
    submitted: false,
  }),
  mounted(){},
  methods: { 
    handleSubmit(e) {
        this.submitted = true;
        this.$validator.validate().then(valid => {
            if (valid) {
                if(this.newpassword == this.confirmpassword){
                    this.$vs.loading();
                    let data = {
                        "first_name":this.firstname, 
                        "last_name":this.lastname, 
                        "email": this.email,
                        "mobile_number": this.contact,
                        "password": this.newpassword,
                        "user_role": this.user_role
                    };
                    this.$store
                    .dispatch("CreateAdmin",data)
                    .then(response => {
                        this.firstname = this.lastname = this.email = this.contact = this.newpassword = this.confirmpassword ='';
                        this.$nextTick(() => this.$validator.reset())
                        this.$vs.loading.close();
                        this.$vs.notify({
                            title: this.$t("Success"),
                            text: this.$t('create_admin.AdminCreatedSuccessfully'),
                            color: "success",
                            position: "top-center"
                        });
                    })
                    .catch(error => {
                        this.$vs.loading.close();
                        // Error response
                        this.$vs.notify({
                            title: this.$t("create_admin.FailedToCreateAdmin"),
                            text: error,
                            color: "danger",
                            position: "top-center"
                        });
                    });
                } else {
                    this.$vs.loading.close();
                    this.$vs.notify({
                        title: this.$t("create_admin.FailedToCreateAdmin"),
                        text: this.$t("create_admin.ConfirmPasswordFailed"),
                        color: "danger",
                        position: "top-center"
                    });
                    return false;
                }
            }
        });
    },
  },
}
</script>
<style lang="scss">
  .vx-card__actions{
    display: none;
  }
  .vx-card{
    box-shadow: 0px 25px 25px 0px rgba(0, 0, 0, 0.1) !important;
    border-radius: 0 !important;
  }
</style>